import { Building2, ContactRound, Search, Settings2 } from 'lucide-react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { EventSwitcher } from './EventSwitcher'
import { flushMutations, pendingCount } from '../services/offlineDb'

const nav = [
  { to: '/enseignes', icon: Building2, label: 'Enseignes' },
  { to: '/contacts', icon: ContactRound, label: 'Contacts' },
  { to: '/events', icon: Settings2, label: 'Salons' },
]

export function AppShell() {
  const navigate = useNavigate()
  const [pending, setPending] = useState(0)

  useEffect(() => {
    const update = () => void pendingCount().then(setPending)
    const sync = () => void flushMutations().catch(() => undefined).finally(update)
    update()
    window.addEventListener('online', sync)
    window.addEventListener('digi-sync-change', update)
    return () => { window.removeEventListener('online', sync); window.removeEventListener('digi-sync-change', update) }
  }, [])

  return <div className="app-shell simple-shell">
    <aside className="sidebar simple-sidebar">
      <button className="brand" onClick={() => navigate('/enseignes')}>
        <span className="brand-mark">D</span><span><strong>DIGI</strong><small>Contacts enseignes</small></span>
      </button>
      <nav>{nav.map(({ to, icon: Icon, label }) => <NavLink key={to} to={to}><Icon size={19} /><span>{label}</span></NavLink>)}</nav>
      <div className="sidebar-foot"><span className={`network-dot ${navigator.onLine ? '' : 'offline'}`} />{navigator.onLine ? 'Données synchronisées' : 'Mode hors connexion'}</div>
    </aside>
    <div className="workspace">
      <header className="topbar">
        <EventSwitcher />
        <div className="topbar-actions">
          {pending > 0 && <span className="sync-badge">{pending} modification{pending > 1 ? 's' : ''} en attente</span>}
          <button className="icon-button" aria-label="Rechercher une enseigne" onClick={() => navigate('/enseignes?focus=search')}><Search size={21} /></button>
        </div>
      </header>
      <main className="main-content"><Outlet /></main>
    </div>
    <nav className="bottom-nav simple-bottom-nav">{nav.map(({ to, icon: Icon, label }) => <NavLink key={to} to={to}><Icon size={21} /><span>{label}</span></NavLink>)}</nav>
  </div>
}
